import React, { useState } from 'react';

function DriverAuth({ onLogin }) {
  const [step, setStep] = useState('phone'); // 'phone' or 'otp'
  const [phone, setPhone] = useState('');
  const [otp, setOtp] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handlePhoneSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Validate phone
    if (phone.length < 9) {
      setError('Please enter a valid phone number');
      return;
    }

    setLoading(true);
    
    // Simulate sending OTP
    setTimeout(() => {
      setLoading(false);
      setStep('otp');
    }, 1000);
  };

  const handleOTPSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Validate OTP (dummy - accept any 6 digits)
    if (otp.length !== 6 || !/^\d+$/.test(otp)) {
      setError('Please enter a valid 6-digit code');
      return;
    }

    setLoading(true);

    // Simulate verification
    setTimeout(() => {
      const driverData = {
        id: 'driver_' + Date.now(),
        phone: phone,
        name: 'Driver ' + phone.slice(-4),
        status: 'available', // available, busy, offline
        currentLocation: {
          lat: 45.4642,
          lng: 9.1900
        },
        stats: {
          totalDeliveries: 0,
          todayDeliveries: 0,
          rating: 5.0,
          totalEarnings: 0
        }
      };
      onLogin(driverData);
      setLoading(false);
    }, 1000);
  };

  const handleBackToPhone = () => {
    setStep('phone');
    setOtp('');
    setError('');
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <div className="logo-section">
            <div className="logo">🚗</div>
            <h1>Homie Driver</h1>
          </div>
          <p className="tagline">Start earning with every delivery</p>
        </div>

        {step === 'phone' ? (
          <form onSubmit={handlePhoneSubmit} className="auth-form">
            <div className="form-group">
              <label htmlFor="phone">Phone Number</label>
              <div className="phone-input-wrapper">
                <span className="country-code">+39</span>
                <input
                  type="tel"
                  id="phone"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value.replace(/\D/g, ''))}
                  placeholder="3XX XXX XXXX"
                  maxLength="10"
                  required
                />
              </div>
            </div>

            {error && <div className="error-message">{error}</div>}

            <button type="submit" className="btn-primary" disabled={loading}>
              {loading ? 'Sending...' : 'Send Verification Code'}
            </button>

            <div className="auth-footer">
              <p>New driver? Contact us to register</p>
              <p className="terms">By continuing, you agree to Homie's Terms of Service</p>
            </div>
          </form>
        ) : (
          <form onSubmit={handleOTPSubmit} className="auth-form">
            <div className="form-group">
              <label htmlFor="otp">Verification Code</label>
              <input
                type="text"
                id="otp"
                value={otp}
                onChange={(e) => setOtp(e.target.value.replace(/\D/g, ''))}
                placeholder="000000"
                maxLength="6"
                className="otp-input"
                required
              />
              <p className="helper-text">
                Code sent to +39 {phone}
              </p>
            </div>

            {error && <div className="error-message">{error}</div>}

            <button type="submit" className="btn-primary" disabled={loading}>
              {loading ? 'Verifying...' : 'Verify & Login'}
            </button>

            <button 
              type="button" 
              className="btn-secondary"
              onClick={handleBackToPhone}
              disabled={loading}
            >
              Change Phone Number
            </button>

            <div className="resend-section">
              <button type="button" className="btn-link">
                Resend Code
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default DriverAuth;
